export function setVisibilityOptions(visibilityOptions) {
   return { type: "SET_VISIBILITY_OPTIONS", visibilityOptions };
}
